import React from 'react';
import { Box, Typography } from '@mui/material';
import CreatorGrid from '../../components/CreatorGrid';

const Results = ({ results }) => {
    if (!results || results.length === 0) {
        return (
            <Box sx={{ textAlign: 'center', mt: 5 }}>
                <Typography variant="h6" color="text.secondary">No results found</Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                    Chat with the assistant to find matching influencers.
                </Typography>
            </Box>
        );
    }

    return (
        <CreatorGrid
            creatorTypes="Influencers Found"
            creatorList={results}
            itemToDisplay={results.length}
        />
    );
};

export default Results;
